import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeFourComponent } from "./components/pages/home-four/home-four.component";
import { AboutComponent } from "./components/pages/about/about.component";
import { HowItWorksComponent } from "./components/pages/how-it-works/how-it-works.component";
import { ContactComponent } from "./components/pages/contact/contact.component";
import { FaqComponent } from "./components/pages/faq/faq.component";
import { ErrorComponent } from "./components/pages/error/error.component";
import { LoginComponent } from "./components/pages/login/login.component";
import { RegisterComponent } from "./components/pages/register/register.component";
import { RequestBookingComponent } from "./components/pages/request-booking/request-booking.component";
import { EditProfileComponent } from "./components/pages/edit-profile/edit-profile.component";
import { PatientAccountComponent } from "./components/pages/patient-account/patient-account.component";
import { DiseaseComponent } from "./components/pages/disease/disease.component";
import { HospitalsListComponent } from "./components/pages/hospitals-list/hospitals-list.component";
import { HospitalViewComponent } from "./components/pages/hospital-view/hospital-view.component";
const routes: Routes = [
    { path: "", component: HomeFourComponent },
    { path: "about", component: AboutComponent },
    { path: "how-it-works", component: HowItWorksComponent },
    { path: "faqs", component: FaqComponent },
    { path: "error", component: ErrorComponent },
    { path: "login", component: LoginComponent },
    { path: "register", component: RegisterComponent },
    { path: "contact", component: ContactComponent },
    { path: "request-booking", component: RequestBookingComponent },
    { path: "edit-profile", component: EditProfileComponent },
    { path: "patient-account", component: PatientAccountComponent },
    { path: "disease", component: DiseaseComponent },
    { path: "hospitals", component: HospitalsListComponent },
    { path: "hospital-view", component: HospitalViewComponent },
    { path: "**", component: ErrorComponent },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
